import type { FaireProductEntity } from "../../entity_types/product";

export const p_nbrbqc7gwb: FaireProductEntity = {
  token: "p_nbrbqc7gwb",
  type: "product",
  name: "Eucalyptus flowers embroidered brooch",
  brandToken: "b_qnhns74hec",
  brandName: "Botanopia USA - gifts , decor and cards for plant lovers",
  imageUrl:
    "https://cdn.faire.com/fastly/44c7b268f1ab94e10c945da5b771fae2c07d2c6359e641257c43ddda978bac5c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bf1afb59f721559d6db1c2db03437e0f34a183cc7cf8cc35ffee4ae63179db12.jpeg",
    "https://cdn.faire.com/fastly/10039b6ab76fb0f32b0ecd83daacddab3f1133269fc78896b3c07d52406abc30.jpeg",
    "https://cdn.faire.com/fastly/51ca80b206a17caaa9aee285b4a8b3805082560257626664c2acd53bd80f8c36.jpeg",
    "https://cdn.faire.com/fastly/1b7e07640ef6c59c1c934e5a9c90263b07044e599778f044a290f1c77f684154.jpeg",
    "https://cdn.faire.com/fastly/4401cbed8f0c2e18c5ea3f2ac90c7e111116069ea8ef36c5eae0fd274241d1ea.jpeg",
    "https://cdn.faire.com/fastly/a2ed1653e5469eab3094f1d2bb229e834c2fc86e975e0db7544ea4828ac3466c.jpeg",
    "https://cdn.faire.com/fastly/e4638c427129f00c6d5d2ecb500be52f27fae8f6b131654fa204de24bfd1acc6.jpeg",
    "https://cdn.faire.com/fastly/79a03d9944b71934e71c54ffe366f0f47b10ce2982adee4d591644f9ed75db4c.jpeg",
    "https://cdn.faire.com/fastly/1d9b6d15bf7efa10f382a810dafd5f86865524f7095cdf027de6d68adaddac18.jpeg",
  ],
  priceDollars: 14.38,
  description:
    "Add a touch of nature to any outfit!\n\nThis brooch was inspired by the amazing flowers of the eucalyptus tree. If you’ve never seen one before, look it up, you won’t be disappointed. They’re showstopping!\n\nThe making process is almost as magical as nature itself: we embroider the leaves on a special fabric that dissolves in water. After a good rinse, *poof* the background has disappeared and the leaves can move freely and naturally. Just like a real plant, but forever. If you’re curious, check out the “video” tab to watch our process.\n\nEach brooch features a gold pin-back, and ships out in a chic black box.\n\nHow to use\n\nNothing easier. Remove the pin-back at the back of the brooch, so you can pin it on any garment and secure it in place on the other side of the fabric. Don’t forget to remove it before you launder your clothing, though!",
  tags: [],
  msrpDollars: 31.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:47.258Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
